export default "__VITE_ASSET__CfD74SQ3__"